import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {MatTableDataSource} from '@angular/material/table';

import {MatPaginator} from '@angular/material/paginator';
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment.prod';

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
  {position: 11, name: 'Sodium', weight: 22.9897, symbol: 'Na'},
  {position: 12, name: 'Magnesium', weight: 24.305, symbol: 'Mg'},
  {position: 13, name: 'Aluminum', weight: 26.9815, symbol: 'Al'},
  {position: 14, name: 'Silicon', weight: 28.0855, symbol: 'Si'},
  {position: 15, name: 'Phosphorus', weight: 30.9738, symbol: 'P'},
  {position: 16, name: 'Sulfur', weight: 32.065, symbol: 'S'},
  {position: 17, name: 'Chlorine', weight: 35.453, symbol: 'Cl'},
  {position: 18, name: 'Argon', weight: 39.948, symbol: 'Ar'},
  {position: 19, name: 'Potassium', weight: 39.0983, symbol: 'K'},
  {position: 20, name: 'Calcium', weight: 40.078, symbol: 'Ca'},
];

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
export interface WebTableData {

  fileType: string;
  fileName: string;
  status: string;
  uploadedBy: string;
  uploadedDate: any

}
@Component({
  selector: 'app-packageupload',
  templateUrl: './packageupload.component.html',
  styleUrls: ['./packageupload.component.scss']
})
export class PackageuploadComponent implements OnInit {
  saas_uri=environment.excel_upload_saas;
  tableDataSource: WebTableData[]=[];
  displayedColumns: string[] = ['filename', 'uri', 'uploadedby', 'uploadeddate'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  file:File=null;

  @ViewChild('packageUpload') packageUpload:ElementRef;
  formGroup:any

  constructor(private toastr: ToastrService,
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder, private cd: ChangeDetectorRef,
    public snackBar: MatSnackBar) { 
      this.formGroup = this.fb.group({
        file: [null, Validators.required]
      });
    }

  ngOnInit() {
    this.displayTableData();
  }

  displayTableData(){
    this.spinner.show();
    this.logbaseService.getFilesData("package").subscribe(result=>{
      this.tableDataSource=result.response;
      this.spinner.hide();
    }, error=>{
      this.spinner.hide();
    })
  }

  getStatus(element:string){

    if(null!=element && element!=undefined && element.toUpperCase().includes('SUCCESS')){
      return "UPLOAD SUCCESS";
    }
    else if(null!=element && element!=undefined && element.toUpperCase().includes('FAIL')){
      return "UPLOAD FAILED";
    }
    else{
      return element;
    }

  }

  reset() {
    this.formGroup.setValue({
      file: null
    });
    console.log(this.packageUpload.nativeElement.files);
    this.packageUpload.nativeElement.value = '';
    console.log(this.packageUpload.nativeElement.files);
  }

  onChange(event){
    this.file=event.target.files[0];
  }

  onCancel(){
    this.reset();
  }

  downloadRackCodesTemplate(){
    window.location.assign(environment.package_template_url);
  }

  upload(){

    if (!this.file) {

      this.snackBar.open('Please Upload a File' , 'Ok', {
      
      duration: 3000,
      
      });
      
      return;
      
      }

    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const formdata = new FormData();
    formdata.append('packageFile', this.file);

    this.spinner.show();
    var responseArray:any=[];
    this.logbaseService.packageDataUpload(formdata, currentUser).subscribe(result => {
      if (result.status.statusCode !== 1) {
        this.snackBar.open('Please check the uploaded file' , 'Ok', {
          duration: 3000,
          });
      } else {
        this.tableDataSource = result.response;
        console.log(JSON.stringify(this.tableDataSource));
      }
      this.displayTableData();
      this.spinner.hide();
    });
    this.reset();
    
  }
  

}
